import request from "@/utils/request";
import { ILogin, IRedirectSignInParams, IFxboSignInParams } from "@/props/IUser";

/**
 * 账号密码登录
 * @param {*} data
 * @returns
 */
export function signIn(data: ILogin) {
  return request({
    url: "/front/signIn",
    method: "POST",
    data,
  });
}

/**
 * 获取用户信息
 * @param {*} params
 * @returns
 */
export function getSession() {
  return request({
    url: "/front/session",
    method: "GET",
  });
}

/**
 * 退出登录
 * @param {*} params
 * @returns
 */
export function logout() {
  return request({
    url: "/front/logout",
    method: "GET",
  });
}

/**
 * 切换角色
 * @param {*} params
 * @returns
 */
export function switchUserApi() {
  return request({
    url: "/front/switchUser",
    method: "POST",
  });
}

/**
 * 授权登录
 * @param {*} params
 * @returns
 */
export function redirectSignIn(params: IRedirectSignInParams) {
  return request({
    url: "/front/redirectSignIn",
    method: "GET",
    params,
  });
}

/**
 * fxbo登录
 * @param {*} data
 * @returns
 */
export function fxboSignIn(data: IFxboSignInParams) {
  return request({
    url: "/front/fxboSignIn",
    method: "POST",
    data,
  });
}

/**
 * App 跳转登录（通过 appToken/ticket）
 * @param {string} ticket - App 传入的 appToken
 * @returns { fxboToken, bssToken, indToken }
 */
export function redirectSignInByTicket(ticket: string) {
  return request({
    url: "/front/redirectSignInByTicket",
    method: "GET",
    params: { token: ticket },
  });
}

/**
 * FXBO 嵌入页（积分商城 widget）带来的 CMS JWT 换商城 token。
 * JWT 走标准 Authorization: Bearer，不是商城自己的 Authori-zation 头
 * @returns { fxboToken }
 */
export function fxboTokenSignIn(jwt: string) {
  return request({
    url: "/front/fxboTokenSignIn",
    method: "POST",
    headers: { Authorization: `Bearer ${jwt}` },
  });
}
